import Reflux from 'reflux';

const actions = Reflux.createActions([
  'fix',
  'unfix',
  'toggle',
  'register',
  'deregister'
]);

export default  actions;



// WEBPACK FOOTER //
// ./frontend/react/actions/fullscreen.js